import { ApiArrayGetter, apiService } from "@/services/api/apiService";
import { enhanceObjectCopy } from "@/helpers/units";

export class PatientListSigItem {
  "template_id": number | null = null;
  "template_name": string | null = null;

  constructor(rawData: Record<string, unknown> = {}) {
    enhanceObjectCopy(rawData, this as Record<string, unknown>);
  }
}

export const API_Contract_patient_list_sig = ApiArrayGetter(
  {
    endpoint: "/contract/patient/list/sig",
    method: "get"
  },
    PatientListSigItem
);
